"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_2 = { class: "text-center" };
const _hoisted_3 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_4 = { class: "text-center" };
const _hoisted_5 = ["href"];
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const ordersStore_1 = require("../../stores/orders/ordersStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'OrderDeliveryInfos',
    setup(__props) {
        var _a, _b, _c, _d;
        const ordersStore = (0, ordersStore_1.useOrdersStore)();
        const orderDeliveryInfos = (0, vue_3.computed)(() => ordersStore.orderDeliveryInfos);
        const orderDeliveryInfoListFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("item_id_delivery_infos_list", "Item ID", "order_delivery_infos")) !== null && _a !== void 0 ? _a : "Item ID",
                value: "id",
            },
            {
                key: "name",
                label: (_b = (0, i18n_1.trans)("name_delivery_infos_list", "Name", "order_delivery_infos")) !== null && _b !== void 0 ? _b : "Name",
                value: "name",
            },
            {
                key: "quantity",
                label: (_c = (0, i18n_1.trans)("quantity_delivery_infos_list", "Quantity", "order_delivery_infos")) !== null && _c !== void 0 ? _c : "Quantity",
                value: "quantity",
            },
            {
                key: "trackingNumber",
                label: (_d = (0, i18n_1.trans)("tracking_url_delivery_infos_list", "Tracking URL", "order_delivery_infos")) !== null && _d !== void 0 ? _d : "Tracking URL",
                value: "trackingNumber",
            },
        ]);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ResponsiveTable_vue_1.default, {
                fields: orderDeliveryInfoListFields.value,
                "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((orderDeliveryInfoListFields).value = $event)),
                items: (0, vue_2.unref)(orderDeliveryInfos),
                striped: "",
                condensed: "",
                panel: ""
            }, {
                "head-quantity": (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("quantity", "Quantity", "order_delivery_infos")), 1)
                ]),
                "cell-quantity": (0, vue_2.withCtx)(({ item: orderDeliveryInfo }) => [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(orderDeliveryInfo.quantity), 1)
                ]),
                "head-trackingNumber": (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("tracking_url", "Tracking URL", "order_delivery_infos")), 1)
                ]),
                "cell-trackingNumber": (0, vue_2.withCtx)(({ item: orderDeliveryInfo }) => {
                    var _a;
                    return [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("a", {
                                href: (_a = orderDeliveryInfo.trackingUrl) !== null && _a !== void 0 ? _a : '',
                                target: "_blank",
                                class: "text-blue font-bold underline"
                            }, (0, vue_2.toDisplayString)(orderDeliveryInfo
                                .trackingNumber), 9, _hoisted_5)
                        ])
                    ];
                }),
                _: 1
            }, 8, ["fields", "items"]));
        };
    }
});
